import { useStoreId } from '@thd-nucleus/experience-context';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { determineItemOrItemTypes } from './utils';

export const useIsMajorAppliance = ({
  itemId,
  itemIds,
  storeId,
  responseOnly,
  isMajorAppliance
}) => {
  const storeIdToUse = storeId || useStoreId();

  if (responseOnly || isMajorAppliance) {
    return {
      isMajorApplianceItemOrItems: isMajorAppliance || null,
      loading: null,
      error: null
    };
  }

  const { data, loading, error } = useProductDeprecated({
    itemIds: (itemId ? [itemId] : itemIds),
    domains: ['identifiers'],
    ssr: false,
    storeId: storeIdToUse,
    skip: storeIdToUse === '8119'
  }, 'clientOnlyProducts');

  return {
    isMajorApplianceItemOrItems: determineItemOrItemTypes(data),
    loading,
    error
  };
};
